<template>
  <div>
      <p v-for="line in details.information" :key="line.line">
          {{line.name}}: {{line.value}}
      </p>
  </div>
</template>

<script>
export default {
  props: {
    serverUrl: {
      type: String,
      default: ""
    },
    showTitle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      details: {}
    };
  },
  created() {
    setTimeout(() => {
      this.startMonitor();
    }, 1000);
  },
  methods: {
    startMonitor() {
      this.$http
        .get(this.serverUrl + "info.php")
        .then(response => {
          this.details = response.data;
          this.$emit("loaded", this.details.hostname);
        })
        .catch(error => {
          setTimeout(() => {
            this.startMonitor();
          }, 1000);
        });
    }
  }
};
</script>

<style scoped>
.subtitle {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// app/monitor/src/components/MonitorInfo.vue